import {
  ExpenditureClassificationSubCategory,
  type BankTransactionClassificationHintDto,
  type ClassificationHintReference,
  type ClassifyAsExpenditureFields,
} from '@signalvote/shared';

/** The hint as the treasurer saw it, sent with a classify so the server can record whether the
 *  submitted values match it (FromHint) or not (FromHintEdited). */
export function classificationHintReference(
  hint: BankTransactionClassificationHintDto,
): ClassificationHintReference {
  return {
    matchKind: hint.matchKind,
    confidence: hint.confidence,
    caution: hint.caution,
    sourceExpenditureId: hint.sourceExpenditureId,
    payeeContactId: hint.payeeContactId,
    category: hint.category,
    purpose: hint.purpose,
    mdExpenseCategory: hint.mdExpenseCategory,
    mdExpensePurpose: hint.mdExpensePurpose,
  };
}

/** One-click Accept: classify the bank line as a general expenditure with exactly the hint's
 *  values. */
export function acceptHintRequest(
  hint: BankTransactionClassificationHintDto,
): Omit<ClassifyAsExpenditureFields, 'bankTransactionConcurrencyVersion'> {
  return {
    subCategory: ExpenditureClassificationSubCategory.GeneralExpenditure,
    contactId: hint.payeeContactId,
    category: hint.category,
    purpose: hint.purpose,
    mdExpenseCategory: hint.mdExpenseCategory,
    mdExpensePurpose: hint.mdExpensePurpose,
    hint: classificationHintReference(hint),
  };
}
